export const PULLDOWN_MARKUP = `<div id="{1}-sel" class="countryPulldownz">
    {0}
  </div>`;
export const WRAPPER_MARKUP = `<div id="{3}-wrap" class="custom-pulldown-wrapper custom-pulldown-wrapper-display-{4}" style="display:{4};">
    {2}{0}{1}
  </div>`;
export const COUNTRY_MARKUP = `<div class="{2}" id="{1}-fld">
    <div class="customSelect clearfix">
      <span class="custom-select-value-display">{0}</span>
      <div class="pullArrow"></div>
    </div>
  </div>`;
export const SEL_COUNTRY = `<span class="custom-pulldown-option {0}" title="{2}">
    {1}
  </span>`;
export const PULLDOWN_LINEITEM = `<div class="countryItem" id="{0}">
    {1}
  </div>`;
export const POPUP_TEMPLATE = `<div id='{0}' class='xpop'>
    <div class='xpop-content-container'>
      <a class='xpop-close xoom-icons'>X</a>
      <div class='xpop-title'>{2}</div>
      <div class='xpop-content'>{1}</div>
    </div>
    <div class='xpop-pointer'>
      <span class='xpop-point xpop-point-border'></span>
      <span class='xpop-point xpop-point-mask'></span>
    </div>
  </div>`;
export const CONTAINER = '<div class="{0}" />';
export const INPUT_MARKUP = '<input type="text" id="{0}-inp" class="helperInput hidden-accessibly" autocomplete="off" />';
export const OUTER_MARKUP = '<ul class="navigation-popover-column">{0}</ul>';
export const INNER_MARKUP = '<li class="navigation-popover__option"><a {0} href="{1}" class="navigation-popover__text">{2}</a></li>';
export const NAVIGATION_PRODUCT = `<li class='navigation-popover__option navigation-popover__option--featured'>
    <a href='{0}' class="navigation-popover__text">{1}</a>
  </li>`;
